import axios from "../../axios";
import {GET_NAVIGATION} from "../types";
import {setAlert} from "./alert";

export const getNavigation = () => async (dispatch) => {
    try {
        const res = await axios.get("user/navigation");
        if (res.data.code === 1) {
            dispatch({type: GET_NAVIGATION, payload: res.data.data});
        }
    } catch (err) {
        dispatch(setAlert(err.message, "danger"));
    }
};